import * as Icon from "@ant-design/icons";
import { Button, Col, Divider, Flex, Row, Space, Typography } from "antd";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "../../../../../util/hooks";
import { setModalRelatorioLancamentoFinanceiro } from "../../../../../redux/slices/relatorio/relatorioSlice";
import { RelatorioLancamentoFinanceiroDrillModel } from "../../../../../models/relatorio/relatorioLancamentoFinanceiroDrillModel";
import { currencyBRL } from "../../../../../util/dinheiroBRAuxiliar";
import TableComponent from "../../../../../components/table/tableComponent";

dayjs.locale("pt-br");

const ModalDetalheRelatorioLancamentos = () => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);

  //hooks
  const dispatch = useAppDispatch();

  const voltar = () => {
    dispatch(setModalRelatorioLancamentoFinanceiro(false));
  };

  const columns: ColumnsType<RelatorioLancamentoFinanceiroDrillModel> = [
    {
      title: "",
      dataIndex: "idLancamento",
      align: "center",
    },
    {
      title: "DATA",
      dataIndex: "data",
      align: "center",
      render: (_, record) => <>{record.data && dayjs(record.data).format("DD/MM/YYYY")}</>,
    },
    {
      title: "CLIENTE/FORNECEDOR",
      dataIndex: "clienteFornecedor",
      render: (_, record) => (
        <Typography.Text style={{ width: 250 }} ellipsis={{ tooltip: record.clienteFornecedor }}>
          {record.clienteFornecedor}
        </Typography.Text>
      ),
    },
    {
      title: "DESCRIÇÃO",
      dataIndex: "historico",
      render: (_, record) => (
        <Typography.Text style={{ width: 250 }} ellipsis={{ tooltip: record.historico }}>
          {record.historico}
        </Typography.Text>
      ),
    },
    {
      title: "Nº DO DOC",
      dataIndex: "numeroDocumento",
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      width: 200,
      render: (_, record) =>
        record.valor < 0 ? <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.valor)}</p> : <p style={{ marginBottom: "0px", color: "blue" }}>{currencyBRL(record.valor)}</p>,
    },
  ];

  return (
    <Flex vertical>
      <TableComponent columns={columns} data={relatorioState.listLancamentoFinanceiroDrill} loading={relatorioState.loadingLancamentoFinanceiroDrill} rowKey="idLancamento" />
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<Icon.CloseOutlined />}>
              FECHAR
            </Button>
          </Space>
        </Col>
      </Row>
    </Flex>
  );
};

export default ModalDetalheRelatorioLancamentos;
